import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { TemplateRef } from '@angular/core';
import { FormArray, ValidatorFn, AbstractControlOptions, AbstractControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export enum TableColumnTypes {
  STRING = 'string',
  DATE = 'date',
  NUMBER = 'number',
  CURRENCY = 'currency',
  TEMPLATE = 'template',
  INPUT_STRING = 'input_string',
  INPUT_NUMBER = 'input_number',
  IDENTIFIER = 'identifier',
}

export enum TableColumnTypesFixed {
  SELECT = 'select',
  DRAG_DROP = 'dragDrop',
  ACTION = 'actions',
}

export enum TableFooterValueTypes {
  SUM = 'sum',
  AVERAGE = 'average',
  MIN = 'min',
  MAX = 'max',
  COUNT = 'count',
}

export enum TableColumnStickyTypes {
  START = 'start',
  END = 'end',
}

export enum TableStickyTypes {
  STICKY = 'sticky',
}

export interface TableAction {
  id: string;
  callback: (row: unknown, action: string) => void;
}

export interface TableColumnAction extends TableAction {
  label: string;
  icon: string;
  disabled: (row: unknown, action: string) => boolean;
  primary?: boolean;
}

export interface TableColumn {
  id: string;
  type: TableColumnTypes;
  label?: string;
  sticky?: TableColumnStickyTypes;
  disableSort?: boolean;
  footerValueTypes?: TableFooterValueTypes;
  customfooterValues?: string[];
  footerDescription?: string;
  template?: TemplateRef<unknown>;
  digitsInfo?: string;
  disableFormatting?: boolean;
  inputConfig?: {
    formArray: FormArray;
    callback?: (row: unknown, control: AbstractControl) => void;
    step?: number;
    options?: ValidatorFn | ValidatorFn[] | AbstractControlOptions;
  };
}

export interface TableConfig {
  dataSource: MatTableDataSource<unknown>;
  columns: TableColumn[];
  hiddenColumns?: string[];
  footer?: boolean | TableStickyTypes | string;
  customFooter?: boolean[];
  header?: boolean | TableStickyTypes;
  selectColumn?: boolean | TableStickyTypes;
  actionColumn?: boolean | TableStickyTypes;
  pagination?: boolean | MatPaginator;
  actions?: TableColumnAction[];
  rowClickAction?: TableAction;
  activeSort?: MatSortable;
  disableCards?: boolean;
  visibleCardColumns?: number;
  primaryColumn?: string;
  scrolling?: boolean;
  width?: string | number;
  height?: string | number;
  wrapperWidth?: string | number;
  wrapperHeight?: string | number;
  hideActionLabel?: boolean;
  dragDrop?: boolean | TableStickyTypes;
  dragDropped?: (event: CdkDragDrop<unknown>, row: unknown) => void;
  alternateRows?: boolean;
}
